import React from 'react';
import KickImage from 'Reuseables/KickImage';
import Styles from './Empty.module.scss';

import { IEmptyProps } from './Empty.definition';

function Empty({}: IEmptyProps) {
  return (
    <div className={Styles['wrapper']}>
      <p className={Styles['title']}>Oh snap, no articles this month!</p>
      <p className={Styles['subtitle']}>
        The articles you're looking for doesn't seem to exists.
      </p>
    </div>
  );
}

export default Empty;
